import React from 'react';

export default function Split(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlSpace="preserve"
            width={218.617}
            height={195.738}
            style={{
                shapeRendering: "geometricPrecision",
                textRendering: "geometricPrecision",
                imageRendering: "optimizeQuality",
                fillRule: "evenodd",
                clipRule: "evenodd",
            }}
            viewBox="0 0 2883 2581"
            className={props.className}
        >
            <defs>
                <style>
                {`
                    #c-${props.id} .fil0 {fill:none}
                    #c-${props.id} .fil2 {fill:#${props.base}}
                    #c-${props.id} .fil1 {fill:#${props.splitColor}}
                    #c-${props.id} .fil3 {fill:#252422;fill-rule:nonzero}
                    #c-${props.id} .fil4 {fill:#${props.sleeve}}
                `}
                </style>
            </defs>
            <g id={`c-${props.id}`}>
                <line className="fil0" x1="953" y1="2561" x2="954" y2= "2561" />
                <line className="fil0" x1="946" y1="2560" x2="947" y2= "2560" />
                <line className="fil0" x1="945" y1="2560" x2="945" y2= "2560" />
                <line className="fil0" x1="941" y1="2560" x2="941" y2= "2560" />
                <line className="fil0" x1="938" y1="2559" x2="939" y2= "2560" />
                <line className="fil0" x1="935" y1="2559" x2="936" y2= "2559" />
                <polygon className="fil1" points="935,2559 935,2559 935,2559 "/>
                <line className="fil0" x1="933" y1="2559" x2="934" y2= "2559" />
                <line className="fil0" x1="931" y1="2559" x2="932" y2= "2559" />
                <polygon className="fil1" points="931,2559 931,2559 931,2559 "/>
                <polygon className="fil1" points="930,2559 931,2559 930,2559 "/>
                <polygon className="fil1" points="929,2559 930,2559 929,2559 "/>
                <line className="fil0" x1="927" y1="2559" x2="928" y2= "2559" />
                <polygon className="fil1" points="959,2561 958,2561 958,2561 "/>
                <polygon className="fil1" points="959,2561 959,2561 "/>
                <polygon className="fil1" points="960,2561 959,2561 "/>
                <polygon className="fil1" points="961,2561 960,2561 "/>
                <polygon className="fil1" points="961,2561 961,2561 "/>
                <polygon className="fil1" points="962,2561 961,2561 "/>
                <polygon className="fil1" points="963,2562 962,2561 "/>
                <polygon className="fil1" points="963,2562 963,2562 "/>
                <polyline className="fil0" points="1163,2575 1162,2575 1161,2575 1161,2575 1160,2575 1160,2575 1161,2575 1162,2575 1162,2575 "/>
                <polyline className="fil0" points="1165,2575 1164,2575 1164,2575 "/>
                <polyline className="fil0" points="1166,2575 1165,2575 1165,2575 "/>
                <polyline className="fil0" points="1168,2575 1167,2575 1167,2575 "/>
                <polyline className="fil0" points="1176,2575 1175,2575 1174,2575 1174,2575 1174,2575 1174,2575 1174,2575 1175,2575 1175,2575 "/>
                <polyline className="fil0" points="1179,2576 1178,2575 1178,2575 "/>
                <polygon className="fil1" points="1181,2576 1180,2576 1180,2576 "/>
                <polygon className="fil1" points="1182,2576 1181,2576 "/>
                <polygon className="fil1" points="1182,2576 1182,2576 "/>
                <line className="fil0" x1="1353" y1="2581" x2="1353" y2= "2581" />
                <line className="fil0" x1="1350" y1="2581" x2="1350" y2= "2581" />
                <line className="fil0" x1="1348" y1="2581" x2="1349" y2= "2581" />
                <line className="fil0" x1="1347" y1="2581" x2="1347" y2= "2581" />
                <polygon className="fil1" points="1345,2581 1347,2581 1345,2581 "/>
                <line className="fil0" x1="1344" y1="2581" x2="1344" y2= "2581" />
                <line className="fil0" x1="1342" y1="2581" x2="1342" y2= "2581" />
                <polygon className="fil1" points="1341,2581 1342,2581 1341,2581 "/>
                <line className="fil0" x1="1339" y1="2581" x2="1340" y2= "2581" />
                <polygon className="fil1" points="1339,2581 1339,2581 1339,2581 "/>
                <polygon className="fil1" points="1338,2581 1339,2581 1338,2581 "/>
                <polygon className="fil1" points="1336,2581 1338,2581 1336,2581 "/>
                <polygon className="fil1" points="1336,2581 1336,2581 1336,2581 "/>
                <polygon className="fil1" points="1335,2581 1336,2581 1335,2581 "/>
                <polygon className="fil1" points="1358,2581 1357,2581 1357,2581 "/>
                <polygon className="fil1" points="1358,2581 1358,2581 "/>
                <polygon className="fil1" points="1359,2581 1358,2581 "/>
                <polygon className="fil1" points="1359,2581 1359,2581 "/>
                <polygon className="fil1" points="1360,2581 1359,2581 "/>
                <path className="fil4" d="M2377 1068l44 45 354 -353 -47 -48 -347 -352c-13,-12 -36,-33 -59,-55 -30,67 -132,319 -102,603l157 159z"/>
                <polygon className="fil1" points="2418,1222 2265,1069 2265,1069 "/>
                <polygon className="fil1" points="1719,6 1725,0 1719,6 "/>
                <path className="fil1" d="M1416 107l7 0c-2,0 -5,0 -7,0z"/>
                <path className="fil1" d="M1415 303l0 -120c123,1 211,-28 268,-57 -48,103 -149,173 -268,177z"/>
                <path className="fil1" d="M1415 2504l0 -2123c178,-4 323,-126 364,-295 7,1 39,6 46,8 107,19 206,43 244,56 46,16 131,59 171,87 11,8 35,29 61,52 -26,56 -138,318 -108,616l0 1554c-88,13 -370,46 -779,46z"/>
                <path className="fil4" d="M160 706l-53 54 346 353 53 -55 159 -164c16,-269 -84,-504 -119,-578 -51,48 -89,90 -89,90l-296 300z"/>
                <path className="fil2" d="M1415 381l0 2123 -3 0c-313,0 -625,-35 -730,-47l0 -1486 1 0c45,-315 -81,-600 -118,-674 24,-22 51,-44 77,-63 46,-33 166,-84 220,-101l20 -6c29,-9 62,-19 106,-30 7,-1 39,-8 46,-10 43,175 187,292 370,292 3,0 7,0 10,0z"/>
                <path className="fil2" d="M1415 184l0 120c-3,0 -7,0 -10,0 -129,0 -231,-69 -278,-181 58,27 147,57 268,61 7,0 14,0 20,0z"/>
                <path className="fil2" d="M1124 33c2,1 3,2 5,3 -2,-1 -3,-2 -5,-3z"/>
                <path className="fil3" d="M1826 93c-7,-1 -39,-7 -46,-8 -42,173 -192,296 -374,296 -183,0 -327,-117 -370,-292 -7,1 -40,8 -46,10 -44,10 -77,21 -106,30l-20 6c-54,16 -175,68 -220,101 -26,19 -53,41 -77,63 36,74 162,359 118,674l-1 0 0 1486c106,12 417,47 730,47 410,0 694,-33 782,-46l0 -1554c-30,-298 82,-560 108,-616 -26,-23 -50,-44 -61,-52 -40,-28 -125,-71 -171,-87 -38,-13 -137,-38 -244,-56zm552 975l44 45 354 -353 -47 -48 -347 -352c-13,-12 -36,-33 -59,-55 -30,67 -132,319 -102,603l157 159zm-2218 -362l-53 54 346 353 53 -55 159 -164c16,-269 -84,-504 -119,-578 -51,48 -89,90 -89,90l-296 300zm1524 -580c-61,31 -155,62 -289,57 -121,-4 -210,-34 -268,-61 47,112 149,181 278,181 124,0 229,-71 278,-177zm-660 -114l0 -2 17 -1c8,-1 17,-3 25,-4l18 -3 4 4 12 -1c0,4 1,8 1,12 20,15 118,82 297,89 217,8 310,-88 314,-92l1 -1c0,-2 0,-5 0,-7l6 0 6 -6 20 2c146,19 297,55 350,74 53,18 143,65 190,97 34,24 138,121 150,132l448 456 -465 461 -154 -153 0 1455 -31 6c-12,2 -304,52 -816,52 -384,0 -756,-51 -760,-52l-29 -5 0 -1462 -164 160 -465 -462 401 -406c3,-3 99,-111 198,-181 60,-43 192,-96 243,-112l19 -6c41,-13 90,-28 163,-42z"/>
            </g>
        </svg>
    );
}
